export default function isSampleProduct (label) {
  if (!label) return false
  return label === 'Sample'
}
